<template>
  <van-popup
    v-model="isShow"
    class="van-popup_question"
    style="position: fixed; width: 100%; height: 100%; background: transparent"
    :overlay="true"
  >
    <div class="question_wrap">
      <span class="btn_close" @click="closeQuestionPopup()"></span>
      <div class="question_con">
        <p class="tit">
          你投递的<span class="job">{{ jobNames }}</span
          >岗位
        </p>
        <p class="tit">HR想询问以下问题</p>
        <p class="ps">回答后有助于提高应聘成功率</p>
        <button class="go_btn" @click="goQuestionInfoPage">去完善</button>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: "JobQuestionEntryPopup",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    jobNames: {
      type: String,
      default: () => {
        return "";
      },
    },
    // appa内嵌 上边距
    appStateHeight: {
      type: [Number, String],
      required: false,
      default: () => 0,
    },
    componentConfig: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isShow: false,
    };
  },
  watch: {
    visible(status) {
      this.isShow = status;
      if (status) {
        this.$sensors.track("WidgetShow", {
          $element_id: "sensor_bcop_popup",
        });
      }
    },
  },
  methods: {
    closeQuestionPopup() {
      this.isShow = false;
      this.$emit("update:visible", false);
    },
    goQuestionInfoPage() {
      this.$emit("goQuestionInfoPage", 2);

      this.$sensors.track("$WebClick", {
        $element_id: "sensor_bcop_popup",
      });
    },
  },
};
</script>

<style lang="less" scoped>
// .van-popup_question {
//   // position: fixed;
//   width: 375px;
//   min-height: 100%;
// }
.question_wrap {
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 311px;
  min-height: 150px;
  background: #fff url("./images/question_popup_bg.png") top center no-repeat;
  background-size: contain;
  border-radius: 16px;

  .btn_close {
    display: block;
    position: absolute;
    content: "";
    width: 20px;
    height: 20px;
    top: 10px;
    left: 10px;
    background: url("./images/question_popup_close.png") center center no-repeat;
    background-size: contain;
  }

  .question_con {
    padding-top: 144px;
    text-align: center;
  }

  .tit {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    font-weight: 600;
    line-height: normal;
    text-align: center;
    color: #000;

    .job {
      display: block;
      max-width: 140px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .ps {
    margin-top: 4px;
    font-size: 16px;
    font-weight: normal;
    text-align: center;
    color: #222222;
  }

  .go_btn {
    display: block;
    width: 200px;
    height: 44px;
    margin: 18px auto;
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
    line-height: 44px;
    text-align: center;
    background: url("./images/question_go_btn.png") center center no-repeat;
    background-size: contain;
    outline: none;
    border: none;
  }
}
</style>
